import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 50px 50px;
`;

export const Header = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  height: 97px;
`;

export const Title = styled(Typography.Header).attrs(() => ({
  $variant: '3',
}))`
  font-size: 22px;
`;

export const CloseButton = styled.button`
  width: 20px;
  height: 20px;
  outline: none;
  border: none;
  cursor: pointer;
  background: none;
  box-shadow: none;
`;

export const Description = styled(Typography.Caption).attrs(() => ({
  $variant: '1',
}))`
  font-size: 16px;
  margin-bottom: 30px;
`;

export const ShareInput = styled.div`
  display: flex;
  align-items: center;
  border-radius: 14px;
  width: 100%;
  height: 52px;
  gap: 10px;
  padding: 0 10px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  background-color: ${({ theme }) => theme.palette.system.lightBackground};
`;

export const ShareButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  gap: 2px;
  height: 38px;
  border-radius: 14px;
  font-size: 15px;
  box-shadow: none;
  outline: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.system.white};
  background-color: ${({ theme }) => theme.palette.brand.main};
`;

export const ShareInputText = styled(Typography.Body).attrs(() => ({
  $variant: '1',
}))`
  flex: 1;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
